import { appUrls } from 'constants/urls';
import axiosInstance from 'utils/axiosInstance';

export const getDoctorInfo = async () => {
  const { data } = await axiosInstance.get(appUrls.currentUser, {
    params: {
      clientApplication: 1
    }
  });
  return data;
};
